import React, {useState} from "react";
import HeartKidney from "../../../assets/images/organs/72x72/Heart-Kidney.png";
import HeartKidneyHover from "../../../assets/images/organs/72x72/Heart-Kidney-Over.png";

function HeartKidneyIcon(props) {
    const [isHover, setIsHover] = useState(false);

    if (props.showHover) {
        return (
            <div 
                className={props.count ? "icon-container organ-count-wrapper" : "icon-container"}
                onMouseEnter={()=> setIsHover(true)}
                onMouseLeave={()=> setIsHover(false)}
            >
                <img src={isHover ? HeartKidneyHover : HeartKidney} alt="Heart Kidney Icon" className="organ-icon large" />
                {props.count &&
                    <div className="organ-count heart-kidney">
                        {props.count}
                    </div>
                }
                
            </div>
        );
    }
    else {
        return (<img src={HeartKidney} alt="Heart Kidney Icon" className="organ-icon large" />);
    }
}

export default HeartKidneyIcon;
